import { format } from '@react-input/number-format';
import { toNumber } from '../utils/toNumber';

export type FieldWrapperValueTypeProps =
    | { type: 'boolean'; value: boolean }
    | { type: 'string'; value: string }
    | { type: 'number'; value: number | null }
    | { type: 'string'; value: null }
    | { type: 'string'; value: undefined };

export type FieldWrapperProps<T> = Omit<T, 'value' | 'type' | 'showCounter'> &
    Partial<FieldWrapperValueTypeProps> & {
        name: string;
    };

export const valueToString = (value: FieldWrapperValueTypeProps['value']) => {
    if (typeof value === 'boolean') {
        return value.toString();
    }
    if (typeof value === 'number') {
        return format(value, {
            maximumFractionDigits: 2,
            groupDisplay: true,
        });
    }
    if (value == null) {
        return '';
    }

    return value;
};

export const valueFromString = (
    type: FieldWrapperValueTypeProps['type'],
    value?: string | null,
) => {
    if (type === 'boolean') {
        return value === 'true';
    }

    if (type === 'number') {
        if (value == null || value.trim() === '') {
            return null;
        }

        return toNumber(value.replaceAll('"', ''));
    }
    return value;
};
